import { serviceTiersArray } from "@/data/serviceTiers";
import { ServiceTierCard } from "./ServiceTierCard";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface ServiceTierGridProps {
  variant?: "standard" | "promo" | "minimal";
  customBadgeText?: string;
  showCompareButton?: boolean;
  onTierSelect?: (tierId: string) => void;
}

export const ServiceTierGrid = ({
  variant = "standard",
  customBadgeText,
  showCompareButton = true,
  onTierSelect
}: ServiceTierGridProps) => {
  const navigate = useNavigate();

  const handleTierSelect = (tierId: string) => {
    if (onTierSelect) {
      onTierSelect(tierId);
    } else {
      // Default behavior: navigate to contact with tier
      const source = variant === "promo" ? "promo_page" : "services_section";
      navigate(`/?tier=${tierId}&source=${source}#contact`);
    }
  };

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {serviceTiersArray.map((tier) => (
          <ServiceTierCard
            key={tier.id}
            tier={tier}
            variant={variant}
            customBadgeText={customBadgeText}
            onSelect={handleTierSelect}
          />
        ))}
      </div>

      {showCompareButton && variant === "standard" && (
        <div className="text-center mt-12">
          <Button 
            size="lg"
            className="bg-gold hover:bg-gold/90 text-gold-foreground font-bold px-8 py-4 text-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            onClick={() => navigate("/pricing")}
          >
            Compare All Plans & Features
          </Button>
        </div>
      )}
    </div>
  );
};
